module.exports = __webpack_public_path__ + "img/app-store-badge.f04755f6.svg";